import { useState, useCallback, useEffect, useRef } from 'react';
import { refreshData as apiRefresh } from '../services/api';

export const useDataRefresh = (fetchFunction, interval = 300000) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const intervalRef = useRef(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fetchFunction();
      setData(result);
      setLastUpdated(new Date());
      setError(null);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [fetchFunction]);

  const refresh = useCallback(async () => {
    try {
      await apiRefresh();
      await fetchData();
    } catch (err) {
      console.error('Error refreshing data:', err);
    }
  }, [fetchData]);

  useEffect(() => {
    fetchData();
    intervalRef.current = setInterval(fetchData, interval);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [fetchData, interval]);

  return { data, loading, error, lastUpdated, refresh, fetchData };
};